import { useState, useEffect } from "react";

import styles from "./ToolTech.module.css";
import { TOOL_TECH } from "../../data/about-data";

const ToolTech = (props) => {
  const [visible, setIsVisible] = useState(false);
  const { scrollOffset } = props;

  useEffect(() => {
    const bodyRect = document.body.getBoundingClientRect();
    const elementRect = document
      .getElementsByClassName(styles["tool-tech"])[0]
      .getBoundingClientRect();

    const offset = elementRect.top - bodyRect.top;

    const elementVisible = scrollOffset + window.innerHeight - offset;
    const elementSize = elementRect.bottom - elementRect.top;

    if (elementVisible >= elementSize / 2) setIsVisible(true);
    else setIsVisible(false);
  }, [scrollOffset]);

  const toolTechList = TOOL_TECH.map((item) => {
    return (
      <li key={item.id}>
        <img
          src={require(`../../assets/icons/tech/${item.id}.svg`)}
          alt={item.name}
        />
      </li>
    );
  });

  return (
    <div className={styles["tool-tech"]}>
      <div className={styles["overlay"]}>
        <h1
          className={`${styles["heading"]} ${
            !visible && styles["heading--hidden"]
          }`}>
          Tools and Technologies
        </h1>
        <ul
          className={`${styles["list"]} ${!visible && styles["list--hidden"]}`}>
          {toolTechList}
        </ul>
      </div>
    </div>
  );
};

export default ToolTech;
